/* NuBest homepage v2.1 (sections/nb-home-*.liquid). Vanilla JS, no dependencies, loaded with `defer` by snippets/head_assets.liquid
   on the home template while the homepage v2.1 switch is on. Tabs of the "Formulas for Every Growing Age" section are run by nb-journey.js.
   1. Proof strip: each item opens its <dialog> (centered card on desktop, bottom sheet on phones that can be dragged down);
      X, Esc or a tap outside closes it; the page behind does not scroll. Items are real links to a fallback page until this
      runs (or where <dialog> is missing).
   2. "Shop by age" links: smooth scroll to the formulas section (instant when the visitor asked for reduced motion), focus the H1.
   3. Reveal on scroll (only when <html class="nb-motion">, set in the head by the Theme setting and the visitor's motion
      preference): each block below the screen fades up as it comes into view, grid cards one after another.
   4. Also Available At: Pause / Play button of the mobile marquee.
   5. Signed-in strip: fills the member's Rivo points when Rivo has them (same source as the Rewards page), otherwise stays generic.
   6. Card Quick Shop shown as an icon: accessible name with the product name. */
(function () {
  'use strict';
  window.__nbHome = true; // read by the head script: if this file never runs, it removes html.nb-motion so nothing stays hidden
  if (!document.querySelector('.nbj-root.nbhp')) return;
  var root = document; // every nb-home section has its own .nbj-root.nbhp wrapper
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = window.matchMedia ? window.matchMedia('(min-width: 768px)') : { matches: true };

  /* ---------- 1. proof strip: dialog per item (centered card on desktop, bottom sheet on phones) ---------- */
  var html0 = document.documentElement;
  var canDialog = typeof HTMLDialogElement === 'function' && 'showModal' in HTMLDialogElement.prototype;
  var sheet = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
  function closeDlg(d) {
    if (!d.open || d.classList.contains('is-closing')) return;
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      d.classList.remove('is-closing', 'is-drag');
      d.style.transform = d.style.transition = '';
      d.close();
    }
    if (reduced) { finish(); return; }
    d.classList.add('is-closing');
    d.addEventListener('animationend', finish, { once: true });
    window.setTimeout(finish, 320);
  }
  if (canDialog) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-nbhp-pi]'), function (a) {
      var d = document.getElementById(a.getAttribute('aria-controls'));
      if (!d || d.tagName !== 'DIALOG') return; // stays a link to the fallback page
      a.setAttribute('role', 'button');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) return;
        a.classList.add('is-on');
        var sbw = window.innerWidth - html0.clientWidth; // keep the page from shifting when its scrollbar goes away
        html0.classList.add('nbhp-lock');
        if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
        d.classList.remove('is-closing', 'is-drag');
        d.showModal();
        d.scrollTop = 0;
      });
      a.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); a.click(); }
      });
      d.addEventListener('close', function () {
        html0.classList.remove('nbhp-lock');
        document.body.style.paddingRight = '';
        a.classList.remove('is-on');
        a.focus({ preventScroll: true });
      });
      d.addEventListener('cancel', function (e) { e.preventDefault(); closeDlg(d); }); // Esc: close with the animation
      d.addEventListener('click', function (e) {
        if (e.target.closest('[data-nbhp-close]')) { closeDlg(d); return; }
        var r = d.getBoundingClientRect(); // a click on the dimmed page outside the card
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDlg(d);
      });
      // phones: drag the sheet down to close it (like iOS)
      var y0 = null, t0 = 0, dy = 0;
      d.addEventListener('touchstart', function (e) {
        if (!sheet.matches || d.scrollTop > 0 || e.touches.length !== 1) { y0 = null; return; }
        y0 = e.touches[0].clientY; t0 = Date.now(); dy = 0;
      }, { passive: true });
      d.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        dy = e.touches[0].clientY - y0;
        if (dy <= 0) { d.style.transform = ''; return; }
        if (e.cancelable) e.preventDefault();
        d.classList.add('is-drag');
        d.style.transition = 'none';
        d.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: false });
      d.addEventListener('touchend', function () {
        if (y0 === null) return;
        var fast = dy > 40 && dy / Math.max(Date.now() - t0, 1) > 0.5;
        y0 = null;
        if (dy > 110 || fast) {
          d.style.transition = reduced ? 'none' : 'transform .2s ease';
          d.style.transform = 'translateY(100%)';
          window.setTimeout(function () { d.classList.remove('is-drag'); d.style.transform = d.style.transition = ''; d.close(); }, reduced ? 0 : 200);
        } else if (dy > 0) {
          d.style.transition = 'transform .2s ease';
          d.style.transform = '';
          window.setTimeout(function () { d.classList.remove('is-drag'); d.style.transition = ''; }, 220);
        }
      });
    });
  }
  var strip = root.querySelector('.nbhp-proof__list');
  if (strip && 'IntersectionObserver' in window && !reduced && !desk.matches) {
    var nio = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { strip.classList.add('is-nudge'); nio.disconnect(); }
    }, { threshold: 0.9 });
    nio.observe(strip);
  }

  /* ---------- 2. shop by age ---------- */
  var target = document.getElementById('shop-by-age');
  if (target) {
    Array.prototype.forEach.call(document.querySelectorAll('a[href="#shop-by-age"], a[href$="#shop-by-age"]'), function (a) {
      if (a.hostname && a.hostname !== window.location.hostname) return;
      if (a.pathname && a.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        var h = target.querySelector('h1');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        if (history.replaceState) history.replaceState(null, '', '#shop-by-age');
      });
    });
  }

  /* ---------- 3. reveal on scroll ----------
     Each block of a section (heading, tabs, grids, notes) fades up on its own as it comes into view, and the cards of a grid
     follow one another. Only blocks below the screen at load are touched, and they are hidden here, by this script, so the
     page never depends on it: no script = no hidden content. */
  var html = document.documentElement;
  var wraps = Array.prototype.slice.call(root.querySelectorAll('[data-nb-reveal]'));
  if (html.classList.contains('nb-motion') && wraps.length && 'IntersectionObserver' in window && !reduced) {
    var vh = window.innerHeight || html.clientHeight;
    var units = [];
    wraps.forEach(function (w) {
      Array.prototype.forEach.call(w.children, function (c) {
        var grids = c.matches('.nbhp-stagger') ? [c] : Array.prototype.slice.call(c.querySelectorAll('.nbhp-stagger'));
        grids = grids.filter(function (g) { return !g.closest('[hidden]'); });
        if (grids.length) grids.forEach(function (g) { units.push({ el: g, kids: Array.prototype.slice.call(g.children) }); });
        else if (!c.matches('[hidden]')) units.push({ el: c, kids: null });
      });
    });
    var later = units.filter(function (u) { return u.el.getBoundingClientRect().top > vh * 0.92; });
    later.forEach(function (u) {
      if (u.kids) u.kids.forEach(function (k, i) { k.classList.add('nbr'); k.style.transitionDelay = Math.min(i, 7) * 80 + 'ms'; });
      else u.el.classList.add('nbr');
    });
    function show(u) { (u.kids || [u.el]).forEach(function (k) { k.classList.add('is-in'); }); }
    if (later.length) {
      var ioAlive = false;
      var rio = new IntersectionObserver(function (es) {
        ioAlive = true;
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          later.forEach(function (u) { if (u.el === e.target) show(u); });
          rio.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      later.forEach(function (u) { rio.observe(u.el); });
      // failsafes: the observer never answers (broken browser), or the page is printed
      window.setTimeout(function () { if (!ioAlive) later.forEach(show); }, 3000);
      window.addEventListener('beforeprint', function () { later.forEach(show); });
    }
  }

  /* ---------- 4. marquee pause ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('.nbhp-mq__pause'), function (btn) {
    var mq = btn.parentNode.querySelector('.nbhp-mq') || root.querySelector('.nbhp-mq');
    if (!mq) return;
    btn.addEventListener('click', function () {
      var paused = mq.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    });
  });

  /* ---------- 6. card Quick Shop shown as an icon: give each one its product name for screen readers ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('.nbhp-cards .nb-shop-btn'), function (b) {
    var n = b.closest('.nb-shop-card'), name = n && n.querySelector('.nb-shop-name');
    if (name) b.setAttribute('aria-label', (b.hasAttribute('data-action-quickshop') ? 'Quick shop ' : 'View ') + name.textContent.replace(/\s+/g, ' ').trim());
  });

  /* ---------- 5. member points (Rivo) ---------- */
  var pts = root.querySelector('[data-nbhm-pts]');
  if (pts) {
    var ticks = 0;
    // 4 Nov 2026: Rivo puts the live balance from its API in Rivo.common.customer.status_points_tally; Rivo.common.customer.points_tally
    // is the value printed with the page and can be stale (0 while the account shows 98,488). Use the live value, else Rivo's
    // own store (filled from the same API on pages with Rivo blocks); never the printed value. No answer in ~16 s: generic line.
    function live() {
      var rc = window.Rivo && Rivo.common && Rivo.common.customer, v = rc && rc.status_points_tally;
      if (typeof v === 'string' && v !== '' && !isNaN(+v)) v = +v;
      return typeof v === 'number' ? v : null;
    }
    function stored() {
      var c = null;
      try { c = window.RivoAlpine && RivoAlpine.store('customer'); } catch (e) {}
      return c && typeof c.points_tally === 'number' ? c.points_tally : null;
    }
    var timer = window.setInterval(function () {
      var l = live(), n = l != null ? l : stored();
      ticks++;
      if (n != null) {
        pts.querySelector('b').textContent = Number(n).toLocaleString('en-US') + ' ' + (n === 1 ? 'point' : 'points');
        pts.hidden = false;
        var generic = root.querySelector('[data-nbhm-generic]');
        if (generic) generic.hidden = true;
      }
      if (l != null || ticks > 40) window.clearInterval(timer);
    }, 400);
  }
})();
